import { useState } from "react";
import Card from "../UI/Card";
import Button from "../UI/Button";
import ModalDialog from "../UI/ModalDialog";
import Text from "../UI/Text";
import Title from "../UI/Title";
// @ts-expect-error pure js
import SignatureMailForm from "./SignatureMailForm";
// @ts-expect-error pure js
import { handleAPIError } from "../../utils/index.jsx";
// @ts-expect-error pure js
import useLoader from "../../hooks/use-loader.js";
import styles from "./MailSignature.module.css";

interface MailSignatureProps {
  customization?: { mail_signature?: string | null } | null;
  onSave: (data: { mail_signature?: string | null }) => Promise<unknown>;
  onReset: (fieldsToReset: string[]) => Promise<unknown>;
  isProfile?: boolean;
}

export default function MailSignature({
  customization,
  onSave,
  onReset,
  isProfile,
}: MailSignatureProps) {
  const [modalOpen, setModalOpen] = useState(false);

  async function saveHandler(values: { mail_signature?: string | null }) {
    await onSave(values);
    setModalOpen(false);
  }

  const [resetting, resetHandler] = useLoader(async () => {
    try {
      await onReset(["mail_signature"]);
    } catch (e) {
      handleAPIError(e);
    }
  });

  const [deleting, deleteHandler] = useLoader(async () => {
    try {
      await onSave({ mail_signature: null });
    } catch (e) {
      handleAPIError(e);
    }
  });

  return (
    <>
      <ModalDialog
        size="md"
        open={modalOpen}
        onOpenChange={setModalOpen}
        header="Signature mail"
      >
        <SignatureMailForm onSave={saveHandler} customization={customization} />
      </ModalDialog>
      <Card className={styles.card}>
        <div className={styles.header}>
          <Title variant="hecto" weight="medium">
            Signature mail
          </Title>
          <Button
            variant="secondary"
            onClick={() => setModalOpen(true)}
            requiresWrite
          >
            Modifier
          </Button>
        </div>
        <Text color="muted">Personnalisez la signature des mails envoyés.</Text>
        <Text weight="medium">Signature :</Text>
        <pre className={styles.signaturePreview}>
          {customization?.mail_signature}
        </pre>
        <div className={styles.actions}>
          <Button
            type="button"
            variant="tertiary"
            onClick={resetHandler}
            isLoading={resetting}
            requiresWrite
          >
            Utiliser la signature par défaut
          </Button>
          {isProfile && (
            <Button
              type="button"
              variant="tertiary"
              onClick={deleteHandler}
              isLoading={deleting}
              requiresWrite
            >
              Utiliser la signature du compte
            </Button>
          )}
        </div>
      </Card>
    </>
  );
}
